import { api } from "./api";

export const GetVisitorTraffic = async (
  visitortrafficid: number,
  mallid: number,
  year: number,
  number: number,
  page: number
) => {
  try {
    const url = `/tenant/v1/getvisitortraffic?visitortrafficid=${visitortrafficid}&mallid=${mallid}&year=${year}&number=${number}&page=${page}`;
    const response = await api.get(url);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
